import {
  AlertCircle,
  CheckIcon,
  InfoIcon,
  Loader2Icon,
  XIcon,
} from 'lucide-react'
import { useTheme } from 'next-themes'
import { Toaster as Sonner, type ToasterProps } from 'sonner'

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      icons={{
        success: (
          <div className="relative flex size-4">
            <CheckIcon className="text-success-600 absolute inset-0 size-4 translate-x-px" />
            <div className="border-success-600/30 absolute -inset-1 rounded-full border-2" />
            <div className="border-success-600/10 absolute -inset-2 rounded-full border-2" />
          </div>
        ),
        info: (
          <div className="relative flex size-4">
            <InfoIcon className="absolute inset-0 size-4 translate-x-px text-blue-600" />
            <div className="absolute -inset-1 rounded-full border-2 border-blue-600/30" />
            <div className="absolute -inset-2 rounded-full border-2 border-blue-600/10" />
          </div>
        ),
        warning: (
          <div className="relative flex size-4">
            <AlertCircle className="text-warning-600 absolute inset-0 size-4 translate-x-px" />
            <div className="border-warning-600/30 absolute -inset-1 rounded-full border-2" />
            <div className="border-warning-600/10 absolute -inset-2 rounded-full border-2" />
          </div>
        ),
        error: (
          <div className="relative flex size-4">
            <XIcon className="text-error-600 absolute inset-0 size-4 translate-x-px" />
            <div className="border-error-600/30 absolute -inset-1 rounded-full border-2" />
            <div className="border-error-600/10 absolute -inset-2 rounded-full border-2" />
          </div>
        ),
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius)',
        } as React.CSSProperties
      }
      {...props}
      closeButton
    />
  )
}

export { Toaster }
